import {
    createApiRef,
    DiscoveryApi,
    FetchApi,
} from "@backstage/core-plugin-api";
import { KubernetesApi, kubernetesApiRef } from "@backstage/plugin-kubernetes";

import { Kinds } from "./kinds";
import { pluginId } from "./routes";
import { K8sResource } from "./types";

export { kubernetesApiRef };

export const K8sDashboardApiRef = createApiRef<K8sDashboardApi>({
    id: pluginId,
});

export interface K8sDashboardApi {
    fetchClusters(): Promise<{ name?: string; authProvider?: string }[]>;
    fetchK8sData(
        clusterName: string,
        kind: keyof typeof Kinds,
        namespace?: string
    ): Promise<K8sResource[]>;
}

export class K8sDashboardClient implements K8sDashboardApi {
    private clustersPromise: Promise<
        { name?: string; authProvider?: string }[]
    > | null = null;

    constructor(
        private readonly kubernetesApi: KubernetesApi,
        private readonly discoveryApi: DiscoveryApi,
        private readonly fetchApi: FetchApi
    ) {}

    async fetchClusters(): Promise<{ name?: string; authProvider?: string }[]> {
        if (!this.clustersPromise) {
            this.clustersPromise = this.kubernetesApi.getClusters();
        }
        return this.clustersPromise;
    }

    async fetchK8sData(
        clusterName: string,
        kind: keyof typeof Kinds,
        namespace?: string
    ): Promise<K8sResource[]> {
        const path = (Kinds[kind].path && Kinds[kind].path(namespace)) || "";

        const baseUrl = await this.discoveryApi.getBaseUrl("kubernetes");
        const res = await this.fetchApi.fetch(`${baseUrl}/proxy${path}`, {
            headers: { "Backstage-Kubernetes-Cluster": clusterName },
        });

        if (res?.status !== 200) {
            throw new Error("Failed to fetch data from cluster.");
        }

        const json = (await res.json()) as { items?: K8sResource[] };
        return json?.items ?? [];
    }
}
